export default theme => ({
  link: {
    cursor: "pointer"
  }
});
